import { render } from "./UserOutOfOfficeEditor.vue?vue&type=template&id=441c3241"
import script from "./UserOutOfOfficeEditor.vue?vue&type=script&lang=ts"
export * from "./UserOutOfOfficeEditor.vue?vue&type=script&lang=ts"
script.render = render

export default script